import { motion } from "framer-motion";
import NextArrow from "@/components/landing/NextArrow";
import { ArrowRight } from "lucide-react";

const areas = [
  { num: "01", title: "Derecho Civil", desc: "Contratos, arrendamientos, sucesiones y responsabilidad civil con estrategia procesal precisa." },
  { num: "02", title: "Derecho Mercantil", desc: "Litigio mercantil, títulos de crédito y controversias comerciales para empresas y personas." },
  { num: "03", title: "Derecho Penal", desc: "Defensa penal integral en todas las etapas del proceso, con experiencia desde el Poder Judicial." },
  { num: "04", title: "Derecho Laboral", desc: "Representación patronal y de trabajadores ante juntas y tribunales laborales." },
  { num: "05", title: "Amparo y Litigio Constitucional", desc: "Protección de derechos fundamentales frente a actos de autoridad." },
];

const PracticeAreas = () => (
  <section id="practica" className="screen py-16 md:py-20 bg-[var(--gm-paper)]" data-testid="practice-areas-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-12">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="mb-8 max-w-2xl"
      >
        <p className="text-xs tracking-[0.3em] uppercase font-semibold text-[var(--gm-accent)] mb-4">Manifiesto de práctica</p>
        <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight">
          Áreas donde ejercemos <span className="italic text-[var(--gm-accent)]">con dominio</span>
        </h2>
      </motion.div>

      <div className="border-t border-[var(--gm-line)]">
        {areas.map((a, i) => (
          <motion.div
            key={a.num}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.7, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
            className="chapter-row group border-b border-[var(--gm-line)] py-4 md:py-5 px-4 md:px-8 grid md:grid-cols-12 gap-4 items-center cursor-default"
            data-testid={`practice-area-${a.num}`}
          >
            <span className="chapter-num md:col-span-1 font-serif-display text-2xl italic text-[var(--gm-muted)]">{a.num}</span>
            <h3 className="chapter-title md:col-span-5 font-serif-display text-2xl md:text-3xl font-medium tracking-tight">{a.title}</h3>
            <p className="chapter-desc md:col-span-5 text-sm font-light text-[var(--gm-muted)] leading-relaxed">{a.desc}</p>
            <div className="md:col-span-1 flex md:justify-end">
              <ArrowRight className="chapter-arrow w-6 h-6 text-[var(--gm-accent)]" strokeWidth={1.5} />
            </div>
          </motion.div>
        ))}
      </div>
    </div>
        <NextArrow to="trayectoria" />
</section>
);

export default PracticeAreas;
